import { useTranslation } from 'react-i18next';

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20lifestyle%20composition%20with%20organic%20textiles%20and%20natural%20ceramic%20pieces%20on%20soft%20cream%20surface%2C%20gentle%20diffused%20daylight%2C%20elegant%20scandinavian%20interior%20aesthetic%2C%20harmonious%20warm%20neutral%20palette%2C%20editorial%20product%20styling%20with%20tactile%20linen%20and%20subtle%20botanical%20elements%2C%20serene%20sophisticated%20atmosphere&width=1800&height=900&seq=cta-v2-bg-2026&orientation=landscape"
          alt="CTA Hintergrund"
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/70 via-foreground-950/40 to-foreground-950/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 px-4 md:px-10">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8 max-w-6xl mx-auto">
          {/* Left - Title */}
          <div className="lg:max-w-lg">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-background-50 leading-tight lowercase">
              {t('cta.title')}
            </h2>
          </div>

          {/* Center - Button */}
          <div className="flex-shrink-0">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-background-50 text-foreground-900 text-sm md:text-base font-medium hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer h-14"
            >
              <span>{t('cta.button')}</span>
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-900 text-background-50">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
          </div>

          {/* Right - Description */}
          <div className="lg:text-right">
            <p className="text-sm md:text-base text-background-200 leading-relaxed">
              {t('cta.description_line1')}<br />
              {t('cta.description_line2')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}